@use '~/theme/theme' as *;

.container {
  @include shadow(lg);

  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: z-index(aside);
  background-color: white;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  transform: translateX(100%);
  transition: transform 200ms ease-in-out;

  &.open {
    transform: translateX(0);
  }

  &.closing {
    transform: translateX(100%);
  }
}

.resizeHandle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
  background: color(grey-600);
  z-index: 1;

  &:hover {
    background: color(violet-600);
  }

  &:active {
    background: color(violet-500);
  }
}

.closeIconContainer {
  position: absolute;
  background: color(violet-600);
  left: -28px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  top: 40px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  box-shadow: 0 4px 4px 0 rgb(102 114 255 / 30%);
  cursor: pointer;
  color: white;
}

.content {
  flex: 1;
  overflow-y: auto;
  height: 100%;
}

.dragOverlay {
  position: fixed;
  inset: 0;
  cursor: col-resize;
  z-index: z-index(modal);
  user-select: none;
}
